/** @format */

export const POST_IMPORTERS_REQUEST = "POST_IMPORTERS_REQUEST";
export const POST_IMPORTERS_SUCCESS = "POST_IMPORTERS_SUCCESS";
export const POST_IMPORTERS_FAILURE = "POST_IMPORTERS_FAILURE";
